import LectureWorkloadSummaryStatusItemResourceModel from '../../generated/types/model/resource/LectureWorkloadSummaryStatusItemResourceModel';

export default class LectureWorkloadSummaryStatusItemResourceViewModel extends LectureWorkloadSummaryStatusItemResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
